"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ton": {
    "2b89a0a6": [{
      "hkey": "97191fcd",
      "slug": "ton",
      "name": "Ton",
      "primary": true,
      "skipSearch": false
    }],
    "comino": [{
      "hkey": "97191fcd",
      "slug": "ton",
      "name": "Ton",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "481b51b7": [{
      "hkey": "261311a5",
      "slug": "masi-di-vigo",
      "name": "Masi di Vigo",
      "primary": true,
      "skipSearch": false
    }],
    "masi": [{
      "hkey": "261311a5",
      "slug": "masi-di-vigo",
      "name": "Masi di Vigo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "732732df": [{
      "hkey": "97191fcd",
      "slug": "ton",
      "name": "Ton",
      "primary": true,
      "skipSearch": false
    }],
    "nosino": [{
      "hkey": "97191fcd",
      "slug": "ton",
      "name": "Ton",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8bf99b45": [{
      "hkey": "97191fcd",
      "slug": "ton",
      "name": "Ton",
      "primary": true,
      "skipSearch": false
    }],
    "rocchetta": [{
      "hkey": "97191fcd",
      "slug": "ton",
      "name": "Ton",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;